export default __webpack_public_path__ + "static/media/iphone_shere.da6e62ea.jpg";